import { create } from "zustand";

const useThemeStore = create((set) => {
  const savedTheme = localStorage.getItem("theme") || "light";
  document.documentElement.classList.toggle("dark", savedTheme === "dark");

  // Set initial body classes for background and text color
  if (savedTheme === "dark") {
    document.body.classList.add("bg-[#181818]", "text-white");
  } else {
    document.body.classList.add("bg-white", "text-black");
  }

  return {
    theme: savedTheme,
    toggleTheme: () =>
      set((state) => {
        const newTheme = state.theme === "light" ? "dark" : "light";
        localStorage.setItem("theme", newTheme);
        document.documentElement.classList.toggle("dark", newTheme === "dark");
        if (newTheme === "dark") {
          document.documentElement.classList.add("dark");
          document.body.classList.remove("bg-white", "text-black");
          document.body.classList.add("bg-[#181818]", "text-white");
        } else {
          document.documentElement.classList.remove("dark");
          document.body.classList.remove("bg-[#181818]", "text-white");
          document.body.classList.add("bg-white", "text-black");
        }
        return { theme: newTheme };
      }),
    setTheme: (theme) => {
      set((state) => {
        const newTheme =
          theme === "light" || theme === "dark" ? theme : "light";
        localStorage.setItem("theme", newTheme);
        document.documentElement.classList.toggle("dark", newTheme === "dark");
        if (newTheme === "dark") {
          document.documentElement.classList.add("dark");
          document.body.classList.remove("bg-white", "text-black");
          document.body.classList.add("bg-[#181818]", "text-white");
        } else {
          document.documentElement.classList.remove("dark");
          document.body.classList.remove("bg-[#181818]", "text-white");
          document.body.classList.add("bg-white", "text-black");
        }
        return { theme: newTheme };
      });
    },
  };
});

const updateTheme = (theme) => {
  document.documentElement.classList.toggle("dark", theme === "dark");
  if (theme === "dark") {
    document.documentElement.classList.add("dark");
    document.body.classList.remove("bg-white", "text-black");
    document.body.classList.add("bg-[#181818]", "text-white");
  } else {
    document.documentElement.classList.remove("dark");
    document.body.classList.remove("bg-[#181818]", "text-white");
    document.body.classList.add("bg-white", "text-black");
  }
};

export default useThemeStore;
